import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this._onScroll = null;
    this._movedToBody = false;
    this._relocating = false;
    this._scrollBound = false;
  }

  connectedCallback() {
    // Move to body so later page sections cannot cover this top bar.
    if (!this._movedToBody && this.parentElement !== document.body) {
      document.querySelectorAll("sticky-add-cart").forEach((el) => {
        if (el !== this) el.remove();
      });
      this._relocating = true;
      this._movedToBody = true;
      document.body.appendChild(this);
      this._relocating = false;
      return; // reconnects after move
    }

    if (this._scrollBound) return;
    this._scrollBound = true;
    this.bindScroll();
  }

  disconnectedCallback() {
    // Ignore the disconnect caused by relocating into <body>
    if (this._relocating) return;

    if (this._onScroll) {
      window.removeEventListener("scroll", this._onScroll);
      window.removeEventListener("resize", this._onScroll);
      this._onScroll = null;
      this._scrollBound = false;
    }
  }

  bindScroll() {
    const _this = this;
    this.main =
      document.querySelector(".sec__main-product") ||
      document.querySelector(".main-product-section");
    if (!this.main) {
      this._scrollBound = false;
      return;
    }

    const primaryBtn = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryBtn) {
      this._scrollBound = false;
      return;
    }

    let isVisible = true;

    this._onScroll = () => {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight || 1;
      const isMobile = window.matchMedia("(max-width: 1024.98px)").matches;
      const footerCovers =
        isMobile &&
        footer &&
        footer.getBoundingClientRect().top < viewportHeight - 100;

      if (footerCovers) {
        _this.classList.remove("show-sticky-cart");
        document.documentElement.classList.remove("show-sticky-cart-active");
        isVisible = true;
        return;
      }

      const buyButtonsInView =
        buttonRect.top < viewportHeight && buttonRect.bottom > 0;

      if (!isVisible && buyButtonsInView) {
        isVisible = true;
        _this.classList.remove("show-sticky-cart");
        document.documentElement.classList.remove("show-sticky-cart-active");
      } else if (isVisible && buttonRect.bottom <= 0) {
        isVisible = false;
        _this.classList.add("show-sticky-cart");
        document.documentElement.classList.add("show-sticky-cart-active");
        document
          .querySelector(".site-header")
          ?.classList.add("header-sticky-hidden");
      }
    };

    window.addEventListener("scroll", this._onScroll, { passive: true });
    window.addEventListener("resize", this._onScroll, { passive: true });
    this._onScroll();
  }
}

if (!customElements.get("sticky-add-cart")) {
  customElements.define("sticky-add-cart", StickyAddCart);
}

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();
